/**
 * Dashboard (personal landing page) constants.
 */

/** KPI poll cadence, matching `src/hooks/useSidebarCounts.ts` and the Overview. */
export const DASHBOARD_POLL_MS = 60_000;

/** Rows shown in each "needs attention" list before "View all". */
export const ATTENTION_LIST_SIZE = 5;

/** Days without activity before one of my cases is flagged as needing attention. */
export const STALE_DAYS = 14;

/** Sessions shown in the upcoming list. */
export const UPCOMING_SESSION_COUNT = 6;
